import { makeAutoObservable } from 'mobx'
import { ESocketEvents } from '@lbs/shared-rp-types'
import { ILimitConfig } from '@lbs/shared-rp-types/dist/game'

export interface IRpGame {
  id: string
  name: string
  limit: Pick<ILimitConfig, 'min' | 'max' | 'maxPayout' | 'id' | 'name'>
}

type RpSocketApi = {
  emit: (event: string, ...args: any[]) => void
  on: (event: string, listener: (...args: any[]) => void) => void
  off: (event: string, listener?: (...args: any[]) => void) => void
}

export class GamesStore {
  games: IRpGame[] = []

  isLoading = false

  private gamesHandler: ((data: { games: IRpGame[] }) => void) | null = null

  private socketApi: RpSocketApi | null = null

  constructor() {
    makeAutoObservable(this)
  }

  startLobbyGamesFeed = (socketApi: RpSocketApi): void => {
    this.stopLobbyGamesFeed()
    this.socketApi = socketApi

    this.gamesHandler = (data: { games: IRpGame[] }) => {
      this.setGames(data?.games ?? [])
      this.isLoading = false
    }

    this.isLoading = true
    socketApi.on(ESocketEvents.GAMES, this.gamesHandler)
    socketApi.emit(ESocketEvents.GET_GAMES, null)
  }

  stopLobbyGamesFeed = (): void => {
    if (this.socketApi && this.gamesHandler) {
      this.socketApi.off(ESocketEvents.GAMES, this.gamesHandler)
    }
    this.gamesHandler = null
    this.socketApi = null
    this.isLoading = false
  }

  setGames = (data: IRpGame[]): void => {
    this.games = data
  }
}
